module.exports = __webpack_public_path__ + "static/media/SharpSansTRIAL-Bold.28be8f18.woff";